/**
 * @generated SignedSource<<eacaadcf72926c0aba5b20c31ab03199>>
 * @relayHash 98fd2b6970f280d77846c12d4fbc3f29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5cf4f9a703d62bd2a8533178b0a0aa399f1de2f3c946bddac7ffc8b2f7fbc28f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type JiraUpdateVersionArchivedStatusInput = {
  id: string;
  isArchived: boolean;
};
export type actions_updateVersionArchivedMutation$variables = {
  input: JiraUpdateVersionArchivedStatusInput;
};
export type actions_updateVersionArchivedMutation$data = {
  readonly jira: {
    readonly updateVersionArchivedStatus: {
      readonly success: boolean;
      readonly version: {
        readonly status: JiraVersionStatus | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type actions_updateVersionArchivedMutation = {
  response: actions_updateVersionArchivedMutation$data;
  variables: actions_updateVersionArchivedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "status"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "actions_updateVersionArchivedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionArchivedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actions_updateVersionArchivedMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateVersionPayload",
            "kind": "LinkedField",
            "name": "updateVersionArchivedStatus",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5cf4f9a703d62bd2a8533178b0a0aa399f1de2f3c946bddac7ffc8b2f7fbc28f",
    "metadata": {},
    "name": "actions_updateVersionArchivedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "072694ea470a98bb3011a1ec0f8078ca";

export default node;
